<template>
  <section class="">
    <FlexWrapper :justifyB="true" class="flex-col my-6 gap-y-4 lg:flex-row">
      <div>
        <FlexWrapper
          :justifyB="true"
          class="px-2 py-2 text-xs font-medium border rounded-md lg:px-4 lg:text-sm border-grey50 gap-x-4 text-foundationGrey900"
        >
          <div
            @click="tab = 'OH'"
            :class="`${tab === 'OH' ? active : inActive}`"
            class="cursor-pointer"
          >
            Orders
          </div>
          <div
            @click="tab = 'PC'"
            :class="`${tab === 'PC' ? active : inActive}`"
            class="cursor-pointer"
          >
            Price Change
          </div>
          <div
            @click="tab = 'CP'"
            :class="`${tab === 'CP' ? active : inActive}`"
            class="cursor-pointer"
          >
            Customer Price
          </div>
          <div
            @click="tab = 'IL'"
            :class="`${tab === 'IL' ? active : inActive}`"
            class="cursor-pointer"
          >
            Inventory
          </div>
          <div
            @click="tab = 'SL'"
            :class="`${tab === 'SL' ? active : inActive}`"
            class="cursor-pointer"
          >
            Settings Log
          </div>
        </FlexWrapper>
      </div>
      <div class="flex flex-col items-center lg:flex-row gap-y-4">
        <TableDateWrapper>
          <vue-ctk-date-time-picker
            id="fromDate"
            v-model="dateRange"
            range
            :onlyDate="true"
            :autoClose="true"
            color="#00903a"
            format="YYYY-MM-DD"
            formatted="ll"
            :disable-time="true"
            :without-header="false"
            time-zone
            :customShortcuts="customShortcuts"
            locale
            :no-label="true"
            style="height: 1px; padding-top: -20px; width: 400px"
          />
        </TableDateWrapper>

        <div class="flex">
          <ExportButton :text="'Export report'" @download="exportCSV(tab)" />
          <SearchInput
            placeholder="Search"
            :handleQuery="handleQuery"
            :queryValue="queryVal"
            class="w-36"
          />
        </div>
      </div>
    </FlexWrapper>

    <Loader
      v-if="
        orderLoader ||
        inventoryLoader ||
        pricelogLoader ||
        cpricelogLoader ||
        settingsLoader
      "
    />

    <section>
      <DepotOrders
        :exportFileName="exportFileName"
        ref="ordersTable"
        :orders="orders"
        v-if="!orderLoader && tab === 'OH'"
        :pagination="orderPagination"
        :handlePagination="handlePagination"
      />

      <DepotPriceChangeLog
        :exportFileName="exportFileName"
        ref="priceLogTable"
        :priceLog="priceLog"
        v-if="!pricelogLoader && tab === 'PC'"
        :pagination="priceLogPagination"
        :getPriceChangeLog="getPriceChangeLog"
        :handlePagination="handlePagination"
      />

      <DepotCustomerPriceChangeLog
        :exportFileName="exportFileName"
        ref="cpriceLogTable"
        :data="cpriceLog"
        v-if="!cpricelogLoader && tab === 'CP'"
        :pagination="cpriceLogPagination"
        :getCustomerPriceChangeLog="getCustomerPriceChangeLog"
        :handlePagination="handlePagination"
      />

      <DepotInventory
        :exportFileName="exportFileName"
        ref="inventoryTable"
        :inventory="inventory"
        :pagination="inventoryPagination"
        :handlePagination="handlePagination"
        v-if="!inventoryLoader && tab === 'IL'"
      />

      <SettingsLog
        :exportFileName="exportFileName"
        ref="settingsTable"
        :settings="settings"
        :pagination="settingsPagination"
        :handlePagination="handlePagination"
        v-if="!settingsLoader && tab === 'SL'"
      />
    </section>
  </section>
</template>

<script>
//utils
import { formatDate, formatNumber } from "@/utils/formatter";

//services
import depotService from "@/services/depot-service";
import settingsService from "@/services/settings-service";

//libraries
import _ from "lodash";
import moment from "moment";
import Column from "primevue/column";
import Paginator from "primevue/paginator";
import DataTable from "primevue/datatable";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";

//components
import Loader from "@/components/UI/Loader";
import DepotOrders from "@/components/Tables/Depot/DepotOrders.vue";
import Text from "@/components/UI/Text/Text.vue";
import DepotInventory from "@/components/Tables/Depot/DepotInventory.vue";
import SettingsLog from "@/components/Tables/Depot/SettingsLog.vue";
import DepotPriceChangeLog from "@/components/Tables/Depot/DepotPriceChangeLog.vue";
import DepotCustomerPriceChangeLog from "@/components/Tables/Depot/DepotCustomerPriceChangeLog.vue";
import ProductType from "@/components/UI/ProductTypes";
import DTButton from "@/components/UI/Buttons/DTButton.vue";
import SearchInput from "@/components/UI/Inputs/SearchInput.vue";
import FlexWrapper from "@/components/UI/Wrappers/FlexWrapper.vue";
import ExportButton from "@/components/UI/Buttons/ExportButton.vue";
import TableDateWrapper from "@/components/UI/Wrappers/TableDateWrapper.vue";

export default {
  name: "DepotTables",
  props: ["showDrawer", "details", "depotId"],
  components: {
    Text,
    Column,
    Loader,
    DTButton,
    DataTable,
    Paginator,
    SearchInput,
    DepotOrders,
    ProductType,
    FlexWrapper,
    ExportButton,

    DepotInventory,
    SettingsLog,
    TableDateWrapper,
    DepotPriceChangeLog,
    DepotCustomerPriceChangeLog,
    VueCtkDateTimePicker,
  },
  data() {
    return {
      pricelogLoader: false,
      cpricelogLoader: false,
      queryVal: "",
      priceLog: [],
      cpriceLog: [],
      orders: [],
      settings: [],
      inventory: [],
      orderLoader: false,
      inventoryLoader: false,
      settingsLoader: false,
      urlProps: { page: 1, pageLimit: 10, query: "" },
      orderPagination: {},
      inventoryPagination: {},
      settingsPagination: {},
      priceLogPagination: {},
      cpriceLogPagination: {},
      active:
        " px-2 py-1 bg-foundationGreyG20 border rounded-md border-grey50 font-inter text-xs",
      inActive: "text-xs ",
      tab: "OH",

      startDate: moment().subtract(7, "days").format("YYYY-MM-DD"),
      endDate: moment(new Date()).format("YYYY-MM-DD"),
      dateRange: {
        start: moment().subtract(7, "days").format("YYYY-MM-DD"),
        end: moment(new Date()).format("YYYY-MM-DD"),
      },
      customShortcuts: [
        { key: "Today", label: "Today", value: "day" },
        { key: "yesterday", label: "Yesterday", value: "-day" },
        { key: "last7Days", label: "Last 7 Days", value: 7 },
        { key: "lastWeek", label: "Last Week", value: "-isoWeek" },
        { key: "last30Days", label: "Last 30 Days", value: 30 },
        { key: "lastMonth", label: "Last Month", value: "-month" },
        { key: "lastYear", label: "Last Year", value: "-year" },
      ],
    };
  },

  computed: {
    exportFileName() {
      const title =
        this.tab === "OH"
          ? "Orders"
          : this.tab === "IL"
          ? "Inventory Log"
          : this.tab === "PC"
          ? "Price Log"
          : this.tab === "SL"
          ? "Settings Log"
          : "Table";
      return `Depot ${title} from ${formatDate(
        this.dateRange.start
      )} to ${formatDate(this.dateRange.end)}`;
    },
  },
  mounted() {
    this.getDepotOrders();
  },

  watch: {
    tab(newStatus) {
      this.urlProps = { page: 1, pageLimit: 10, query: "" };
      if (newStatus === "OH") {
        this.getDepotOrders();
      }

      if (newStatus === "IL") {
        this.getInventoryLog();
      }

      if (newStatus === "PC") {
        this.getPriceChangeLog();
      }

      if (newStatus === "CP") {
        this.getCustomerPriceChangeLog();
      }

      if (newStatus === "SL") {
        this.getSettingsLog();
      }
    },

    dateRange(newDateRange) {
      if (newDateRange.start && newDateRange.end) {
        this.startDate = newDateRange.start;
        this.endDate = newDateRange.end;
        // console.log(newDateRange.start, newDateRange.end, "akddddd");
        this.urlProps = { page: 1, pageLimit: 10, query: "" };

        this.handleTabClick();
      }
    },

    queryVal(query_) {
      // Get The new page , based on the proper pagination
      this.urlProps = { ...this.urlProps, page: 1, query: query_ };
      this.handleTabClick();
    },
  },

  methods: {
    //utils
    handlePagination(type, pageData) {
      //PageData indicates an object of the change that is to be made
      if (type.toLowerCase() === "reset") {
        this.urlProps = {
          ...this.urlProps,
          page: 1,
          pageLimit: pageData.newLimit,
        };

        this.handleTabClick(this.tab);

        return;
      }
      this.urlProps = { ...this.urlProps, page: pageData.newPage };

      this.handleTabClick(this.tab);
    },

    handleQuery: _.debounce(function (event) {
      this.queryVal = event.target.value;
    }, 500),

    handleTabClick() {
      if (this.tab === "OH") {
        this.getDepotOrders();
      }

      if (this.tab === "IL") {
        this.getInventoryLog();
      }

      if (this.tab === "PC") {
        this.getPriceChangeLog();
      }

      if (this.tab === "CP") {
        this.getCustomerPriceChangeLog();
      }

      if (this.tab === "SL") {
        this.getSettingsLog();
      }
    },

    //Request

    async getSettingsLog() {
      this.settingsLoader = true;
      const data = {
        depotId: this.depotId,
      };
      try {
        const result = await depotService.getDepotSettingsLog(
          data
          // this.urlProps
        );

        let index = 0;
        result.data.forEach((el) => {
          el.index = ++index;
          // el.dateReceived = formatDate(el.dateReceived);
        });

        this.settingsPagination = result.pagination;
        this.settings = result.data;
        this.settingsLoader = false;
      } catch (err) {
        this.settingsLoader = false;
      }
    },

    async getInventoryLog() {
      this.inventoryLoader = true;
      const data = {
        startDate: this.startDate,
        endDate: this.endDate,
        depotId: this.depotId,
      };
      try {
        const result = await depotService.getDepotInventoryLog(
          data,
          this.urlProps
        );

        let index = 0;
        result.data.forEach((el) => {
          el.index = ++index;
          el.dateReceived = formatDate(el.dateReceived);
        });

        this.inventoryPagination = result.pagination;
        this.inventory = result.data;
        this.inventoryLoader = false;
      } catch (err) {
        this.inventoryLoader = false;
      }
    },

    sortByKey(array, key) {
      return array.sort(function (a, b) {
        var x = a[key];
        var y = b[key];
        return x < y ? -1 : x > y ? 1 : 0;
      });
    },

    async getPriceChangeLog() {
      this.pricelogLoader = true;
      const data = {
        startDate: this.startDate,
        endDate: this.endDate,
        depotId: this.depotId,
      };
      try {
        const result = await depotService.getDepotPriceChangeLog(
          data,
          this.urlProps
        );

        this.priceLog = result.data;
        let index = 0;
        if (result) {
          result.data.forEach((el) => {
            el.index = ++index;
            el.maxCapacity = el.maxCapacity;
            el.price = el.price;
            el.currentQuantity = el.currentQuantity;
          });

          this.priceLogPagination = result.pagination;

          this.priceLog = this.sortByKey(result.data, dateAdded);
        }
        this.pricelogLoader = false;
      } catch (err) {
        this.pricelogLoader = false;
      }
    },

    async getCustomerPriceChangeLog() {
      this.cpricelogLoader = true;
      const defaultGuid = this.depotId;
      // const data = {
      //   startDate: this.startDate,
      //   endDate: this.endDate,
      //   depotId: this.depotId,
      // };

      try {
        const result = await settingsService.getPriceControl(
          defaultGuid,
          this.dateRange,
          this.urlProps
        );
        if (result) {
          // console.log(result.data);

          result.data.forEach((order, index) => {
            order.effectiveDate = moment(order.effectiveDate).format(
              "DD-MMM-YYYY h:mm A"
            );
            order.endDate = moment(order.endDate).format("DD-MMM-YYYY h:mm A");
            order.isUsed = order.isUsed ? "Used" : "Unused";
          });
          this.cpriceLog = result.data;
          this.cpricelogLoader = false;
          // this.PriceControlResults = result.data;
          // console.log(result.data);
          // this.allDatas = result.data;

          this.cpriceLogPagination = result.pagination;
        }
      } catch (err) {
        this.cpricelogLoader = false;
      }

      // try {
      //   const result = await depotService.getDepotPriceChangeLog(
      //     data,
      //     this.urlProps
      //   );

      //   this.cpriceLog = result.data;
      //   let index = 0;
      //   if (result) {
      //     result.data.forEach((el) => {
      //       el.index = ++index;
      //       el.maxCapacity = el.maxCapacity;
      //       el.price = el.price;
      //       el.currentQuantity = el.currentQuantity;
      //     });

      //     this.cpriceLogPagination = result.pagination;

      //     this.cpriceLog = this.sortByKey(result.data, dateAdded);
      //   }
      //   this.cpricelogLoader = false;
      // } catch (err) {
      //   this.cpricelogLoader = false;
      // }
    },

    async getDepotOrders() {
      this.orderLoader = true;
      let data = {
        id: this.depotId,
        startDate: this.startDate,
        endDate: this.endDate,
        status: this.status,
      };

      try {
        const result = await depotService.getDepotOrders(data, this.urlProps);

        if (result) {
          let index = 0;
          result.data.forEach((el) => {
            el.index = ++index;
            el.date = formatDate(el.date);
            // el.quantity = formatNumber(el.quantity)
            // el.totalAmount = formatNumber(el.totalAmount)
          });

          this.orderPagination = result.pagination;
          this.orders = result.data;
        }
        this.orderLoader = false;
      } catch (err) {
        this.orderLoader = false;
      }
    },

    //utilities
    exportCSV() {
      if (this.tab === "OH") {
        this.$refs.ordersTable.exportTable();
      }

      if (this.tab === "IL") {
        this.$refs.inventoryTable.exportTable();
      }

      if (this.tab === "PC") {
        this.$refs.priceLogTable.exportTable();
      }

      if (this.tab === "CP") {
        this.$refs.cpriceLogTable.exportTable();
      }

      if (this.tab === "SL") {
        this.$refs.settingsTable.exportTable();
      }
    },
  },
};
</script>

<style scoped>
.vue-ctk-date-time-picker {
  /* background-color: red !important; */
  height: 10px; /* Adjust the height as needed */
}
</style>
